export default __webpack_public_path__ + "static/media/647.51242deb.png";